import { NgModule } from '@angular/core';
import { LogoComponent } from './logo.component';
import {NgIf} from "@angular/common";

@NgModule({
    declarations: [LogoComponent],
    imports: [NgIf],
    exports: [LogoComponent],
})
export class LogoModule {}
